import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'acs-info-bulle',
  imports: [MatButtonModule, MatIconModule, CommonModule],
  templateUrl: './info-bulle.component.html',
  styleUrls: ['./info-bulle.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBulleComponent {
  #infoBulleMessage!: string;
  @Input() set infoBulleMessage(message: string) {
    this.#infoBulleMessage = message;
  }
  // Gestion de la position
  tooltipStyle: { [key: string]: string } = {};

  get infoBulleMessage(): string {
    return this.#infoBulleMessage;
  }

  public isDisplayed: boolean = false;

  public toggleInfoBulle(event: MouseEvent): void {
    this.isDisplayed = !this.isDisplayed;
    if (this.isDisplayed) {
      this.setPosition(event);
    }
  }

  @HostListener('document:click', ['$event'])
  public onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!(this.isDisplayed && target.closest('.blue-icon'))) {
      this.isDisplayed = false;
    }
  }

  public setPosition(event: MouseEvent): void {
    const targetRect = (event.target as HTMLElement).getBoundingClientRect();
    const left = targetRect.left - 24;
    if (window.innerWidth <= 1224) {
      this.tooltipStyle = {
        left: `-${left}px`
      };
    } else {
      this.tooltipStyle = { left: '0' };
    }
  }
}
